import { useCodatAuth } from "@codat/client-cookie-manager";
import * as React from "react";

interface JwtResponse {
  [prop: string]: unknown;
}

function decodeUnicode(str: string) {
  return decodeURIComponent(
    atob(str)
      .split("")
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
}

export function jwtDecode(token: string): JwtResponse {
  try {
    return JSON.parse(decodeUnicode(token.split(".")[1]));
  } catch (e) {
    throw new Error("Invalid token.");
  }
}

const useJwtProp = (prop: string): string => {
  const [jwtValue, setJwtValue] = React.useState<string>("");
  const auth = useCodatAuth();

  React.useEffect(() => {
    const token = auth.userData?.access_token;
    if (token) {
      try {
        const value = jwtDecode(token)[prop] || "";
        setJwtValue(value + "");
      } catch (e) {
        setJwtValue("");
      }
    }
  }, [prop, auth.userData?.access_token]);

  return jwtValue;
};

export default useJwtProp;
